// extracted by mini-css-extract-plugin
export default {"root":"_5slck","small":"_1SECf","normal":"Iyg_Y"};